import { checkoutResource } from './resource'

export const checkoutService = {
  getTransports: (signal) => (body) => checkoutResource.post('/transport/costs', body, { signal: signal() }),
  checkout: (signal) => (body) => checkoutResource.post('/checkout', body, { signal: signal() })
}
